<template>
    <div class="facturas w-full h-full bg-color-01 flex flex-col flex-grow" :class="[!isCollapsed ? 'wide-table-width':'tight-table-width']">
      <div class="w-full flex items-center px-5 h-13 bg-primary-700">
        <p class="text-xs">Enviar facturas</p>
      </div>
      <div v-if="enviandoFactura" class="w-full flex items-center px-5 h-13 bg-orange-700 left-5">Enviando factura. Una vez completada la operación se le redirigirá al listado de facturas donde la recién enviada aparecerá la primera</div>
      <div class="w-full dz-max-h-resp relative z-10">
        <vue-dropzone id="attachfiles"
          :include-styling="false"
          :options="dropzoneOptions"
          :useCustomSlot=true
          @vdropzone-removed-file ="filesRemoved"
          @vdropzone-files-added="filesAdded"
          @vdropzone-error="errorDropZone"
          ref="dropZone">
            <div class="dropzone-custom-content w-full px-2 sticky top-0">
                <div class="dz-custom-message w-full">
                    <div class="w-full flex items-center h-14 px-4 mt-4 upload-button rounded">
                        <h3 class="dropzone-custom-title text-grey-darkest"><span class="hidden md:inline-block"><span class="text-light font-medium">Arrastre</span> las facturas aquí, o </span> haga <span class="text-light font-medium">click</span> para añadir</h3>
                    </div>
                </div>
            </div>
        </vue-dropzone>
      </div>
      <div :class="{'mb-16': invoiceType && provider && company}" class="px-2 flex-grow overflow-hidden my-4">
        <transition name="fade-up">
          <div v-if="invoicesUploaded" class="bg-primary-800 px-2 py-2 rounded-lg w-full h-full overflow-auto">
            <div class="flex flex-col md:flex-row">
              <div class="w-2/3 sm:w-1/2 md:pr-12">
                <div class="px-2 pb-2">
                  <p class="text-lg sm:text-xl md:text-2xl text-light">Asignar factura a:</p>
                </div>
                <div class="flex flex-col pb-4 px-2 w-full">
                  <label for="invoiceType" class="text-primary-200 text-sm pb-2">Tipo de Factura<span style="color:red"> *</span></label>
                  <Select class="w-full" id="invoiceType" v-model="invoiceType" placeholder="Seleccione tipo…">
                    <Option v-for="invoiceType in invoiceTypes" :value="invoiceType" :key="invoiceType">
                    </Option>
                  </Select>
                </div>
                <div class="flex flex-col lg:flex-row ">
                  <div class="flex flex-col pb-4 px-2 w-full lg:w-full">
                    <label for="provider" class="text-primary-200 text-sm pb-2">Proveedor (emisor)<span style="color:red"> *</span></label>
                    <Select class="w-full" id="provider" v-model="provider" placeholder="Seleccione proveedor…">
                      <Option v-for="provider in providers" :value="provider" :key="provider">
                      </Option>
                    </Select>
                  </div>
                  <div class="flex flex-col pb-4 px-2 w-full lg:w-1/2" v-if="cifVisible">
                    <label for="cif" class="text-primary-200 text-sm pb-2">CIF proveedor</label>
                    <Select class="w-full" id="cif" v-model="cif" placeholder="Seleccione CIF empresa…">
                      <Option v-for="cif in cifsE" :value="cif" :key="cif">
                      </Option>
                    </Select>
                  </div>
                </div>
                <div class="flex flex-col lg:flex-row items-end">
                  <div class="flex flex-col pb-4 px-2 w-full lg:w-1/2">
                    <label for="company" class="text-primary-200 text-sm pb-2">Empresa (receptor)<span style="color:red"> *</span></label>
                    <Select class="w-full" id="company" v-model="company" placeholder="Seleccione empresa…">
                      <Option v-for="company in companies" :value="company.value" :key="company.value">{{ company.label }}</Option>
                    </Select>
                  </div>
                  <div class="pb-4 px-2 w-full lg:w-1/2 mb-2">
                    <checkbox v-model="isp" @change="LimpiarCuotas">Inversión Sujeto Pasivo</checkbox>
                  </div>
                </div>
                <div class="flex flex-col pb-4 px-2 w-full">
                  <label for="numberid" class="text-primary-200 text-sm pb-2">Número de factura<span style="color:red"> *</span></label>
                  <Input type="text" maxlength="20" show-word-limit id="numberid" v-model="numberid" placeholder="Número de factura…"/>
                </div>
                <div class="flex flex-col lg:flex-row">
                  <div class="flex flex-col pb-4 px-2 lg:w-1/2">
                    <label for="name" class="text-primary-200 text-sm pb-2">Fecha de emisión<span style="color:red"> *</span></label>
                    <date-picker id="date" v-model="date"/>
                  </div>
                  <div class="flex flex-col pb-4 px-2 lg:w-1/2">
                    <label for="total" class="text-primary-200 text-sm pb-2">Total factura</label>
                    <Input type="text" id="total"  v-model="total" disabled placeholder="Total…"/>
                  </div>
                </div>
                <div class="flex flex-col xl:flex-row">
                  <div class="flex flex-col pb-4 px-2 xl:w-1/3">
                    <label for="ocode" class="text-primary-200 text-sm pb-2">Código de obra<span style="color:red"> *</span></label>
                    <Input type="text" maxlength="12" show-word-limit id="ocode" v-model="ocode" placeholder="Código de obra…"/>
                  </div>
                  <div class="flex flex-col pb-4 px-2 xl:w-2/3" v-if="ordernumberVisible">
                    <label for="ordernumber" class="text-primary-200 text-sm pb-2">Número de pedido</label>
                    <Input type="text" maxlength="20" show-word-limit id="ordernumber" v-model="ordernumber" placeholder="Número de pedido…"/>
                  </div>
                </div>
                <div class="flex flex-col pb-4 px-2 w-full">
                  <label for="comments" class="textarea-primary-200 text-sm pb-2">Comentarios<span style="color:red"> *</span></label>
                  <Input type="textarea" maxlength="100" show-word-limit id="comments" v-model="comments" placeholder="Comentarios…"/>
                </div>
              </div>
              <div class="w-2/3 sm:w-1/2">
                <div class="px-2 pb-2 w-full">
                  <p class="text-lg sm:text-xl md:text-2xl text-light">Líneas de impuestos:</p>
                </div>
                <div class="px-2 pb-2 w-full">
                  <p class="text-md sm:text-lg md:text-xl text-light">Impuesto 1</p>
                </div>
                <div class="flex flex-wrap">
                  <div class="flex flex-col pb-4 px-2 w-full lg:w-1/2 xl:w-1/3">
                    <label for="base1" class="text-primary-200 text-sm pb-2">Base<span style="color:red"> *</span></label>
                    <InputNumber id="base1" :precision="2" :step="0.1"   @change="CalcularImpuesto1" v-model="base1" placeholder="Base…"/>
                  </div>
                  <div class="flex flex-col pb-4 px-2 w-full lg:w-1/2 xl:w-1/3">
                    <label for="IVA1" class="text-primary-200 text-sm pb-2">IVA<span style="color:red"> *</span></label>
                    <Select class="w-full" id="IVA1" v-model="iva1"  @change="CalcularImpuesto1" placeholder="Seleccione base…">
                      <Option v-for="iva1 in ivas1" :value="iva1" :key="iva1">
                      </Option>
                    </Select>
                  </div>
                  <div class="flex flex-col pb-4 px-2 w-full xl:w-1/3">
                    <label for="cuota1" class="text-primary-200 text-sm pb-2">Cuota</label>
                    <InputNumber id="cuota1" :precision="2" :step="0.1" v-model="cuota1"  @change="CalcularTotalFactura" :disabled="isp" placeholder="Cuota…"/>
                  </div>
                </div>
                <div class="px-2 pb-2 w-full">
                  <p class="text-md sm:text-lg md:text-xl text-light">Impuesto 2</p>
                </div>
                <div class="flex flex-wrap">
                  <div class="flex flex-col pb-4 px-2 w-full lg:w-1/2 xl:w-1/3">
                    <label for="base2" class="text-primary-200 text-sm pb-2">Base</label>
                    <InputNumber id="base2" :precision="2" :step="0.1" v-model="base2"  @change="CalcularImpuesto2" placeholder="Base…"/>
                  </div>
                  <div class="flex flex-col pb-4 px-2 w-full lg:w-1/2 xl:w-1/3">
                    <label for="IVA2" class="text-primary-200 text-sm pb-2">IVA</label>
                    <Select class="w-full" id="IVA2" v-model="iva2"  @change="CalcularImpuesto2" placeholder="Seleccione base…">
                      <Option v-for="iva2 in ivas2" :value="iva2" :key="iva2">
                      </Option>
                    </Select>
                  </div>
                  <div class="flex flex-col pb-4 px-2 w-full xl:w-1/3">
                    <label for="cuota2" class="text-primary-200 text-sm pb-2">Cuota</label>
                    <InputNumber id="cuota2" :precision="2" :step="0.1" v-model="cuota2"  @change="CalcularTotalFactura" :disabled="isp" placeholder="Cuota…"/>
                  </div>
                </div>
                <div class="px-2 pb-2 w-full">
                  <p class="text-md sm:text-lg md:text-xl text-light">Impuesto 3</p>
                </div>
                <div class="flex flex-wrap">
                  <div class="flex flex-col pb-4 px-2 w-full lg:w-1/2 xl:w-1/3">
                    <label for="base3" class="text-primary-200 text-sm pb-2">Base</label>
                    <InputNumber id="base3"  :precision="2" :step="0.1" v-model="base3"  @change="CalcularImpuesto3" placeholder="Base…"/>
                  </div>
                  <div class="flex flex-col pb-4 px-2 w-full lg:w-1/2 xl:w-1/3">
                    <label for="IVA3" class="text-primary-200 text-sm pb-2">IVA</label>
                    <Select class="w-full" id="IVA3" v-model="iva3" @change="CalcularImpuesto3" placeholder="Seleccione base…">
                      <Option v-for="iva3 in ivas3" :value="iva3" :key="iva3">
                      </Option>
                    </Select>
                  </div>
                  <div class="flex flex-col pb-4 px-2 w-full xl:w-1/3">
                    <label for="cuota3" class="text-primary-200 text-sm pb-2">Cuota</label>
                    <InputNumber id="cuota3" :precision="2" :step="0.1" v-model="cuota3" @change="CalcularTotalFactura" :disabled="isp" placeholder="Cuota…"/>
                  </div>
                </div>
                <div class="px-2 pb-2 w-full">
                  <p class="text-md sm:text-lg md:text-xl text-light">Impuesto 4</p>
                </div>
                <div class="flex flex-wrap">
                  <div class="flex flex-col pb-4 px-2 w-full lg:w-1/2 xl:w-1/3">
                    <label for="base4" class="text-primary-200 text-sm pb-2">Base</label>
                    <InputNumber id="base4" :precision="2" :step="0.1" v-model="base4"  @change="CalcularImpuesto4" placeholder="Base…"/>
                  </div>
                  <div class="flex flex-col pb-4 px-2 w-full lg:w-1/2 xl:w-1/3">
                    <label for="IVA4" class="text-primary-200 text-sm pb-2">IVA</label>
                    <Select class="w-full" id="IVA4" v-model="iva4"  @change="CalcularImpuesto4" placeholder="Seleccione base…">
                      <Option v-for="iva4 in ivas4" :value="iva4" :key="iva4">
                      </Option>
                    </Select>
                  </div>
                  <div class="flex flex-col pb-4 px-2 w-full xl:w-1/3">
                    <label for="cuota4" class="text-primary-200 text-sm pb-2">Cuota</label>
                    <InputNumber id="cuota4" :precision="2" :step="0.1" v-model="cuota4"  @change="CalcularTotalFactura" :disabled="isp" placeholder="Cuota…"/>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </transition>
      </div>
      <div class="w-full absolute bottom-0 right-0 overflow-hidden transition-200 flex items-center px-4 global bg-primary-800" :class="[invoiceType && provider && company && date && ocode && numberid && comments && base1 && iva1 ? 'h-12':'h-0']" style="z-index:1">
        <div class="ml-auto">
          <Button type="primary" @click="onSend()" :disabled="!this.botonActivo" size="small" icon="icon-send"><span class="hidden sm:inline-block pl-2">Enviar factura</span></Button>
        </div>
      </div>
    </div>
</template>
<script>
import { Select, Option, Button, Input, DatePicker, Checkbox } from 'element-ui'
import InputNumber from '@/components/InputNumber'
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import { mapState } from 'vuex'
import sendFactura from '../utils/solpheoSendFactura'
import comprobarCodigoObra from '../utils/portalComprobarCodigoObra'

export default {
  mounted () {
    this.$store.commit('setCIFs')
    fetch('/config.json')
      .then(res => res.json())
      .then(config => {
        this.companies = config.companies || []
      })
      .catch(() => {
        console.error('No se pudo cargar config.json')
      })
  },
  computed: {
    ...mapState(['cifs', 'proveedores']),
    invoicesUploaded: function () {
      return this.invoicesAdded - this.invoicesRejected
    },
    cifsE () { return this.cifs },
    providers () { return this.proveedores }
  },
  name: 'SendInvoices',
  components: {
    vueDropzone: vue2Dropzone,
    Select,
    Option,
    Button,
    Input,
    DatePicker,
    Checkbox,
    InputNumber
  },
  data: function () {
    return {
      facturaName: '',
      facturaFile: '',
      facturaMetadatas: {},
      numberid: '',
      base1: '',
      base2: '',
      base3: '',
      base4: '',
      cuota1: '',
      cuota2: '',
      cuota3: '',
      cuota4: '',
      ordernumber: '',
      ordernumberVisible: false,
      total: '',
      ocode: '',
      date: '',
      isCollapsed: false,
      checked: true,
      invoicesAdded: 0,
      invoicesRejected: 0,
      dropzoneOptions: {
        paramName: 'attachfiles',
        parallelUploads: 1,
        addRemoveLinks: false,
        acceptedFiles: '.pdf',
        maxFiles: 1,
        uploadMultiple: false,
        url: '/',
        autoProcessQueue: false,
        previewTemplate: this.template(),
        maxFilesize: 500
      },
      invoiceType: 'Factura',
      invoiceTypes: ['Factura', 'Factura Rectificativa'],
      provider: '',
      company: null,
      companies: [],
      cif: '',
      cifVisible: false,
      iva1: '',
      ivas1: ['21%', '10%', '4%', '0%'],
      iva2: '',
      ivas2: ['21%', '10%', '4%', '0%'],
      iva3: '',
      ivas3: ['21%', '10%', '4%', '0%'],
      iva4: '',
      ivas4: ['21%', '10%', '4%', '0%'],
      isp: false,
      comments: null,
      botonActivo: true,
      enviandoFactura: false
    }
  },
  methods: {
    CalcularTotalFactura () {
      const totalCalculado = (this.base1 == null ? 0 : parseFloat(this.base1)) +
                   (this.base2 == null ? 0 : parseFloat(this.base2)) + (this.base3 == null ? 0 : parseFloat(this.base3)) + (this.base4 == null ? 0 : parseFloat(this.base4)) +
                   (this.cuota1 == null ? 0 : parseFloat(this.cuota1)) + (this.cuota2 == null ? 0 : parseFloat(this.cuota2)) + (this.cuota3 == null ? 0 : parseFloat(this.cuota3)) +
                   (this.cuota4 == null ? 0 : parseFloat(this.cuota4))
      this.total = totalCalculado.toFixed(2)
    },
    CalcularImpuesto1 () {
      if (!this.isp) {
        this.cuota1 = (this.base1 == null || this.iva1 == null ? 0 : this.base1 * this.iva1.replace('%', '') / 100)
      }
      this.CalcularTotalFactura()
    },
    CalcularImpuesto2 () {
      if (!this.isp) {
        this.cuota2 = (this.base2 == null || this.iva2 == null ? 0 : this.base2 * this.iva2.replace('%', '') / 100)
      }
      this.CalcularTotalFactura()
    },
    CalcularImpuesto3 () {
      if (!this.isp) {
        this.cuota3 = (this.base3 == null || this.iva3 == null ? 0 : this.base3 * this.iva3.replace('%', '') / 100)
      }
      this.CalcularTotalFactura()
    },
    CalcularImpuesto4 () {
      if (!this.isp) {
        this.cuota4 = (this.base4 == null || this.iva4 == null ? 0 : this.base4 * this.iva4.replace('%', '') / 100)
      }
      this.CalcularTotalFactura()
    },
    LimpiarCuotas () {
      if (this.isp) {
        this.cuota1 = 0
        this.cuota2 = 0
        this.cuota3 = 0
        this.cuota4 = 0
        this.CalcularTotalFactura()
      } else {
        this.CalcularImpuesto1()
        this.CalcularImpuesto2()
        this.CalcularImpuesto3()
        this.CalcularImpuesto4()
      }
    },
    async onSend () {
      try {
        // Validamos los impuestos
        if ((this.base2 && !this.iva2) || (!this.base2 && this.iva2) ||
            (this.base3 && !this.iva3) || (!this.base3 && this.iva3) ||
            (this.base4 && !this.iva4) || (!this.base4 && this.iva4)) {
          alert('Por favor revise los impuestos, se debe informar conjuntamente base y tipo de IVA')
        } else {
          this.botonActivo = false
          console.log('Total Factura')
          console.log(this.invoiceType)
          const facturaMetadatas = { TipoFactura: this.invoiceType,
            CIF: this.cif,
            RazonSocial: this.provider,
            Sociedad: this.company,
            Inversion: this.isp,
            FechaEmision: this.date.toLocaleDateString('en-US'),
            NumeroFactura: this.numberid,
            TotalFactura: this.total,
            CodigoObra: this.ocode,
            NumeroPedido: this.ordernumber,
            Comentarios: this.comments,
            Impuesto1: this.base1,
            Iva1: this.iva1,
            Cuota1: this.cuota1,
            Impuesto2: this.base2,
            Iva2: this.iva2,
            Cuota2: this.cuota2,
            Impuesto3: this.base3,
            Iva3: this.iva3,
            Cuota3: this.cuota3,
            Impuesto4: this.base4,
            Iva4: this.iva4,
            Cuota4: this.cuota4 }
          // Comprobamos que el código Obra exista
          const { Estado } = await comprobarCodigoObra(JSON.stringify(facturaMetadatas))
          if (Estado === 'KO') {
            alert('El código de obra indicado no existe')
            this.botonActivo = true
          } else {
            this.enviandoFactura = true
            const { Estado, Mensaje, Facturas } = await sendFactura(this.facturaName, this.facturaFile, JSON.stringify(facturaMetadatas))

            if (Estado === 'KO') {
              if (Mensaje === 'Token caducado') {
                alert('Sesión Caducada, por favor, inicie sesión nuevamente')
                localStorage.removeItem('token')
                this.$router.push({ name: 'login' })
              } else {
                this.error = true
                this.enviandoFactura = false
                this.botonActivo = true
                alert('Ha ocurrido un error, por favor, refresque la página e inténtelo de nuevo')
              }
            } else {
              console.log('Factura dada de alta en solpheo con datos: ' + Facturas[0])
              this.$store.commit('addFactura', Facturas[0])
              this.$router.push({ name: 'home' })
            }
          }
        }
      } catch (error) {
        this.error = true
        this.enviandoFactura = false
        alert('Ha ocurrido un error, por favor, refresque la página e inténtelo de nuevo')
      }
    },
    template: function () {
      return `<div class="dz-preview dz-file-preview px-2">
                <div class="w-full relative border-b-dz-items">
                  <div class="flex w-full items-center h-14 items-center">
                    <div class="dz-details flex w-full">
                        <div class="dz-filename">
                          <span class="pl-2 runcate text-grey-darkest" data-dz-name></span>
                        </div>
                        <div class="ml-auto px-4">
                          <span>11 dic. 2019</span>
                        </div>
                        <div class="pr-2 dz-size text-xs mt-1 text-grey-darker px-4">
                          <span data-dz-size></span>
                        </div>
                    </div>
                    <div class="dz-success-mark hidden pr-2"><span class="icon-check text-success text-xs"></span></div>
                    <div class="dz-error-mark text-danger hidden pr-2"><span class="icon-alert"></span></div>
                    <div data-dz-remove class="px-2 click cursor-pointer dz-remove text-primary-500 hover:text-secondary"><span class="icon-delete"></span></div>
                  </div>
                  <div class="relative w-full">
                    <div class="dz-progress transition-200 w-full absolute h-1 bg-primary-500 left-0 bottom-0 rounded-full overflow-hidden"><span class="dz-upload transition-200 w-0 h-1 block bg-secondary" data-dz-uploadprogress></span></div>
                    <div class="dz-error-message text-xs text-red"><span data-dz-errormessage></span></div>
                  </div>
                </div>
              </div>`
    },
    filesAdded: function (file) {
      this.facturaName = file[0].name
      const totalAdded = this.invoicesAdded + file.length
      this.invoicesAdded = totalAdded
      const reader = new FileReader()
      reader.readAsDataURL(file[0])
      reader.addEventListener('load', () => {
        this.facturaFile = reader.result
      })
    },
    filesRemoved: function (file) {
      this.invoicesAdded--
      console.log('Entramos en filesRemoved()...')
      // Eliminamos de rejected aquellos ficheros que al agregarlos al DZ y antes de subirlos
      // no cumplen con la opción acceptedFiles del DZ para calcular correctamente al final
      // cuantos ficheros se han subido
      if (this.invoicesRejected > 0) this.invoicesRejected--
    },
    errorDropZone: function (file, xhr) {
      console.log('Entramos en errorDropZone()...')
      // OJO!!! aquí cuenta tambien los ficheros que no son válidos por que no cumplen
      // con los indicados en la opcion acceptedFiles (DZ) al agregarlos al DZ
      this.invoicesRejected++
    }
  }
}

</script>
